export const demoCampaigns = [
  {
    referencenumber: 0,
    name: 'Florida - Developers',
    status: 'active',
    effective_status: 'effective',
    budget_spent: 3000000,
    budget: 5000000,
    clicks: 5000,
    conversions: 20,
    impressions: 15000,
    spend: 3000000,
    friendly_status: 'running'
  },
  {
    referencenumber: 1,
    name: 'New York - Truck Drivers',
    status: 'active',
    effective_status: 'effective',
    budget_spent: 8000000,
    budget: 12000000,
    clicks: 2000,
    conversions: 23,
    impressions: 12562,
    spend: 8000000,
    friendly_status: 'running'
  },
  {
    referencenumber: 2,
    name: 'USA - Nursing Staff',
    status: 'active',
    effective_status: 'effective',
    budget_spent: 6000000,
    budget: 9000000,
    clicks: 6523,
    impressions: 25173,
    conversions: 39,
    spend: 6000000,
    friendly_status: 'running'
  },
  {
    referencenumber: 3,
    name: 'Technology Company - Marketing/Business Development',
    status: 'active',
    effective_status: 'effective',
    total_spend: 6000000,
    budget: 9000000,
    clicks: 6523,
    impressions: 25173,
    conversions: 39,
    spend: 6000000,
    friendly_status: 'running'
  }
];

